import { render, staticRenderFns } from "./ProductoBuscadorGeneral.vue?vue&type=template&id=1666fbd8&scoped=true&"
import script from "./ProductoBuscadorGeneral.vue?vue&type=script&lang=js&"
export * from "./ProductoBuscadorGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ProductoBuscadorGeneral.vue?vue&type=style&index=0&id=1666fbd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1666fbd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VIcon,VRow,VSkeletonLoader})
